import State from 'types/State';
import LeadParams from 'types/Apis/LeadParams';
import { useSelector } from 'react-redux';

export interface LeadSubmission {
  isSubmitted: boolean;
  name?: string;
  email?: string;
  phone?: string;
  message?: string;
  zip?: string;
  address?: string;
  sendAlerts?: boolean;
}

export default function useSubmitted(vin: string): LeadSubmission {
  const leadSubmissions = useSelector<State, LeadParams[]>((state) => state.leadSubmissions);
  const submission = leadSubmissions?.find((sub) => sub.lead.vin === vin);
  const isSubmitted = Boolean(submission);
  if (submission) {
    return {
      isSubmitted,
      name: submission.lead.name,
      email: submission.lead.email,
      phone: submission.lead.phone,
      zip: submission.lead.zip,
      message: submission.lead.message,
      address: submission.lead.address,
      sendAlerts: submission.accepts_search_emails,
    };
  }
  return { isSubmitted };
}
